import * as firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAbBDWSXD2Xq5lu9t7323m6U9nObtLFvgw',
  authDomain: 'hot-onion-fasami.firebaseapp.com',
  databaseURL: 'https://hot-onion-fasami.firebaseio.com',
  projectId: 'hot-onion-fasami',
  storageBucket: 'hot-onion-fasami.appspot.com',
  messagingSenderId: '1072539939312',
  appId: '1:1072539939312:web:b8f7bc3c9be409c9bdad35',
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);
